/**
 * @author Fernando Ruano
 * @file index.jsx
 * @description Medical Parameters Creation View Page.
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Components
import FormGenerator from '@nephro/components/FormGenerator';

// Helpers
import {
  bottomOptionsCreateEdit,
  formItemParameters
} from '@nephro/commons/helpers/utils';

// Styles
import styles from './styles.module.css';

const medicalParameterData = {};

/**
 * Medical Parameters Creation View
 * @param { Object } parameterActions - Medical Parameter Actions.
 * @param { Object } actions - App Actions.
 * @return { Node } React node.
 */
const MedicalParametersCreationView = ({ medicalParameterActions }) => {
  const history = useHistory();
  const { createMedicalParameter } = medicalParameterActions;
  const { t: translate } = useTranslation();

  const onGoBack = () => {
    history.goBack();
  };

  // Function to get on submit form values
  const onFinish = (values) => {
    createMedicalParameter(values, onGoBack);
  };

  return (
    <div className="flex flex-col h-full px-7 pt-5 pb-7 ">
      <FormGenerator
        initialValues={medicalParameterData}
        onFinish={onFinish}
        items={formItemParameters(translate)}
        bottomOptions={bottomOptionsCreateEdit(
          onGoBack,
          translate,
          'create',
          styles.actionButton
        )}
      />
    </div>
  );
};

/**
 * Component definition of proptypes.
 */
MedicalParametersCreationView.propTypes = {
  medicalParameterActions: PropTypes.shape({
    createMedicalParameter: PropTypes.func.isRequired
  }).isRequired
};

export default MedicalParametersCreationView;
